export default __webpack_public_path__ + "static/media/check-white.474c8d41.svg";